/**
 * Directory people-search query tracking.
 *
 * Listens for FacetWP's native `facetwp-loaded` CustomEvent (fired on
 * `document` after every facet refresh), debounces while the visitor is
 * still typing, then pushes one event per settled search term to the GTM
 * dataLayer. GTM forwards it to GA4 as `view_search_results`.
 *
 * No jQuery: FacetWP 4.x dispatches real CustomEvents via fUtil.
 */
(function () {
    'use strict';

    // Gate on the people-search surface, not the facet name: the post, news,
    // and program listing blocks reuse the same `search` facet, so tracking
    // FWP.facets.search alone would mislabel their searches. Both the legacy
    // and 2026 person listing wrapper classes are unconditional (the facets
    // themselves are behind ACF toggles). Script is deferred, so the DOM is
    // parsed by now.
    //
    // BOTH selectors are required. Class selectors match whole tokens, so
    // `.wp-block-acf-person-listing-with-facets` does NOT match an element classed
    // `wp-block-acf-person-listing-with-facets-26` — omitting the second one makes this
    // script load and immediately return on every -26 block, silently dropping
    // its search analytics with no console error and no visual symptom.
    if (!document.querySelector('.wp-block-acf-person-listing-with-facets, .wp-block-acf-person-listing-with-facets-26')) {
        return;
    }

    var DEBOUNCE_MS = 2000; // FacetWP's own input delay is ~500ms; this collapses pause-y typing
    var MIN_LENGTH = 2;     // ignore single characters
    var timer = null;
    var lastSent = '';

    function facetValue(name) {
        if (typeof window.FWP === 'undefined' || !window.FWP.facets) {
            return '';
        }
        var val = window.FWP.facets[name];
        if (Array.isArray(val)) {
            val = val.length ? val[0] : '';
        }
        return (typeof val === 'string') ? val.trim() : '';
    }

    function resultsCount() {
        try {
            var total = parseInt(window.FWP.settings.pager.total_rows, 10);
            return isNaN(total) ? null : total;
        } catch (e) {
            return null;
        }
    }

    function send() {
        var term = facetValue('search');
        if (term.length < MIN_LENGTH || term === lastSent) {
            return;
        }
        lastSent = term;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'directory_search',
            // Identifies the people-directory block as the search surface, so its
            // GA4 view_search_results events can be isolated from other sources that
            // share that recommended event name — notably the site-wide Google CSE on
            // /search/, which GA4 Enhanced Measurement logs as view_search_results off
            // the `q` param. Block-presence gating means this can run on any page the
            // block is placed on, so page-path filtering alone is not reliable.
            search_source: 'faculty_directory',
            search_term: term,
            search_department: facetValue('dept_dd'),
            search_results_count: resultsCount()
        });
    }

    document.addEventListener('facetwp-loaded', function () {
        if (facetValue('search') === '') {
            return; // department/pager change with no search term — nothing to track
        }
        clearTimeout(timer);
        timer = setTimeout(send, DEBOUNCE_MS);
    });
})();
